export function addModulesSidebarBanner() {
  if (document.querySelector('#catalog-filter-menu') && !document.querySelector('.modules-sidebar-banner')) {
    let modulesSidebarBanner = document.createElement('div');
    modulesSidebarBanner.classList.add('modules-sidebar-banner')
    modulesSidebarBanner.innerHTML = `
      <br><br>
      <div class="as-module-card as-card as-card--dark">
        <div class="as-module-card__content" style="height:fit-content">
          <img src="https://astronomer.github.io/academy-theme/dist/icons/module.svg" width="48" height="48" alt="" class="as-module-card__badge">
          <div class="as-card__text" style="gap: 1rem">
            <div class="as-card__text-inner">
              <h2 class="as-card__title" style="font-size:24px;margin:16px 0;">Want a more structured learning environment? </h2>
              <p class="as-card__subtitle" style="font-size:18px;margin:16px 0;">Explore our Learning Paths</p>
              <p class="as-card__description" style="font-size:14px;margin:16px 0;">A learning path is a collection of modules that are hand-picked to be completed in order.</p>
            </div>
            <a class="as-card__button as-button" href="/page/learning-paths">Learn More</a>
          </div>
        </div>
      </div>
    `
    let sidebarFilterMenu = document.querySelector('#catalog-filter-menu');
    sidebarFilterMenu && sidebarFilterMenu.insertAdjacentElement('afterend', modulesSidebarBanner);
  }
}